import React from 'react';

import { ucFirst } from 'utils';
import styles from './AvailabilityPill.module.scss';

interface Props {
  availability: string;
  loading?: boolean;
  editable?: boolean;
  background?: string;
  color?: string;
}

const AvailabilityPill: React.FC<Props> = ({ availability, loading, editable = true, background, color }) => {
  return (
    <span
      data-testid="availability-pill"
      className={`${styles.Outer} ${styles[ucFirst(availability.replace(/\s+/g, ''))]} ${loading && styles.Loading}`}
      style={{ backgroundColor: background, color }}
    >
      <div className={styles.Loader}>
        <i className="mm-circle-o-notch mm-spin" />
      </div>
      {ucFirst(availability)}
      {editable && <i className="mm-angle-down" />}
    </span>
  );
};

export default AvailabilityPill;
